import { LABEL_GIFT_TAG_PROMOTION } from "constants/Enums";

const TagGiftComp = ({color= '#D55D2A'}) => (
  <span>
    <span style={{ color }}>{LABEL_GIFT_TAG_PROMOTION}</span>
    <span> - </span>
  </span>
);
export default TagGiftComp;
